export default "__VITE_ASSET__DENDZ_uK__"